import { Component } from '@angular/core';
import { ProductI } from '@interfaces/custom-product';
import { CustomProductReferencesService } from '@services/custom-product-references.service';
import { isNotNullable } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable, filter, map, of, shareReplay, switchMap } from 'rxjs';
@Component({
  selector: 'custom-cx-product-intro',
  standalone: false,
  templateUrl: './custom-product-intro.component.html',
  styleUrls: ['./custom-product-intro.component.scss'],
})
export class CustomProductIntroComponent {
  product$ = this.currentProductService.getProduct().pipe(shareReplay(1)) as Observable<ProductI | null>;
  productIsLoading$ = this.product$.pipe(map((product) => !product));
  productCode$ = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
    map((product) => product.code ?? ''),
  );

  items$ = this.productCode$.pipe(
    filter((productCode) => !!productCode),
    switchMap((productCode) => this.occProductReferenceService.load(productCode).pipe(map((references: any) => references?.products.filter((p: any) => p?.code != productCode)))),
    filter((products) => products?.length > 0),
    map((products) => products.map(product => of(product))),
    shareReplay(1)
  )

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  constructor(
    private currentProductService: CurrentProductService,
    private occProductReferenceService: CustomProductReferencesService,
  ) {}
}
